import { Container, Text } from '@chakra-ui/react'
import { ErrorBoundary } from '@sentry/react'
import { ErrorFallback, withSentryErrorReporting } from '@components/Fallback'
import {
  CheckPermissionsWrapper,
  Operations,
  Permission,
} from '@lib/permissions'
import { RESOURCE_ID } from '@lib/permissions/Resource'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const readLiveInputsPermission = new Permission(
  RESOURCE_ID.live_input,
  Operations.Read
)

const FailOver = ({ error }) => (
  <ErrorFallback title={'Error Loading Live Inputs'} error={error}>
    <>
      <Text mt={2}>There was an error loading your live inputs.</Text>
      <Text>
        Try reloading the page or choosing another item from the side menu
      </Text>
    </>
  </ErrorFallback>
)

const LiveInputRoute = () => (
  <Container maxW={'75rem'}>
    <CheckPermissionsWrapper permissions={[readLiveInputsPermission]}>
      <Outlet />
    </CheckPermissionsWrapper>
  </Container>
)

export const Route = createFileRoute('/_auth/o/$orgId/liveInputs')({
  component: LiveInputRoute,
  beforeLoad: () => ({ getTitle: () => 'Live Inputs' }),
  errorComponent: withSentryErrorReporting(FailOver),
  loader: () => ({
    crumb: 'Live Inputs',
  }),
})
